<template>
  <div>
    <div class="container">
      <app-nav></app-nav>
      <h1>Nouveau contrat !</h1>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-6">
          <form v-on:submit.prevent class="remplacant-form">
            <select
              id="titulaire"
              name="titulaire"
              type="text"
              class="form-control"
              v-on:change="sourceChanged"
              required
            >
              <option value="" selected data-default>
                Choisir le médecin remplacé</option
              >
              <option
                v-bind:value="titulaire.node.id"
                v-bind:key="titulaire.node.id"
                v-for="titulaire in allTitulaires.edges"
              >
                {{ titulaire.node.prenom + " " + titulaire.node.nom }}
              </option>
            </select>
            <select
              name="remplacant"
              type="text"
              class="form-control"
              v-on:change="sourceChangedRemp"
              required
            >
              <option value="" selected data-default>
                Choisir le remplaçant</option
              >
              <option
                v-bind:key="remplacant.node.id"
                v-bind:value="remplacant.node.id"
                v-for="remplacant in allRemplacants.edges"
              >
                {{ remplacant.node.prenom + " " + remplacant.node.nom }}</option
              >
            </select>
            <input
              v-model="date1"
              name="date1"
              type="date"
              class="form-control"
              data-format="EE, dd MMMM yyyy"
              required
            />
            <input
              v-model="date2"
              name="date2"
              type="date"
              class="form-control"
              data-format="EE, dd MMMM yyyy"
            />
            <input
              v-model="date3"
              name="date3"
              type="date"
              class="form-control"
              data-format="EE, dd MMMM yyyy"
            />
            <input
              v-model="date4"
              name="date4"
              type="date"
              class="form-control"
              data-format="EE, dd MMMM yyyy"
            />
            <input
              v-model="date5"
              name="date5"
              type="date"
              class="form-control"
              data-format="EE, dd MMMM yyyy"
            />
            <input
              v-model="date6"
              name="date6"
              type="date"
              class="form-control"
              data-format="EE, dd MMMM yyyy"
            />
            <input
              type="submit"
              value="Valider"
              class="btn btn-primary btn-block"
              @click.stop="addContrat"
            />
          </form>
        </div>
        <div class="col-xs-12.col-sm-4 ">
          <router-link to="/contrats" class="btn btn-primary">
            Retour vers la liste</router-link
          >
          <p class="lead"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppNav from "../AppNav";
import moment from "moment";
import { CONTRATS_PER_PAGE } from "../../constants/settings";
import {
  ALL_CONTRATS_QUERY,
  ACTIFS_REMPLACANTS_QUERY,
  ACTIFS_TITULAIRES_QUERY,
  CREATE_CONTRAT
} from "../../constants/graphql";

const pageSize = 10;

export default {
  name: "contratsNew",
  components: {
    AppNav
  },
  data() {
    return {
      moment: moment,
      allRemplacants: [],
      allTitulaires: [],
      titulaire: null,
      remplacant: null,
      date1: null,
      date2: null,
      date3: null,
      date4: null,
      date5: null,
      date6: null
    };
  },
  apollo: {
    allTitulaires: {
      query: ACTIFS_TITULAIRES_QUERY
    },
    allRemplacants: {
      query: ACTIFS_REMPLACANTS_QUERY
    }
  },
  methods: {
    sourceChanged: function(e) {
      for (var i = 0; i < this.allTitulaires.edges.length; i++) {
        if (this.allTitulaires.edges[i].node.id == e.target.value) {
          this.titulaire = this.allTitulaires.edges[i];
        }
      }
      this.$emit("sourceChanged", e.target.value);
    },
    sourceChangedRemp: function(e) {
      for (var i = 0; i < this.allRemplacants.edges.length; i++) {
        if (this.allRemplacants.edges[i].node.id == e.target.value) {
          this.remplacant = this.allRemplacants.edges[i];
        }
      }
      this.$emit("sourceChangedRemp", e.target.value);
    },
    addContrat: function() {
      const titulaire = this.titulaire;
      const remplacant = this.remplacant;
      const date1 = this.date1;
      const date2 = this.date2;
      const date3 = this.date3;
      const date4 = this.date4;
      const date5 = this.date5;
      const date6 = this.date6;
      var self = this;
      this.$apollo
        .mutate({
          mutation: CREATE_CONTRAT,
          variables: {
            titulaireId: this.titulaire.node.id,
            remplacantId: this.remplacant.node.id,
            date1: this.date1,
            date2: this.date2,
            date3: this.date3,
            date4: this.date4,
            date5: this.date5,
            date6: this.date6
          },
          refetchQueries: [
            {
              query: ALL_CONTRATS_QUERY,
              variables: {
                offset: 0,
                first: CONTRATS_PER_PAGE
              }
            }
          ]
        })
        .then(function(data) {
          self.$router.push({
            name: "Contrats"
          });
        })
        .catch(function(error) {
          // Error
          console.error("error", error);
          // We restore the initial user input
        });
    }
  }
};
</script>
<style scoped>
body {
  padding-top: 3.5rem;
}

h1 {
  margin-bottom: 20px;
  padding-bottom: 9px;
  border-bottom: 1px solid #eee;
}
/*
 * Sidebar
 */

.sidebar {
  position: fixed;
  top: 51px;
  bottom: 0;
  left: 0;
  z-index: 1000;
  padding: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  /* Scrollable contents if viewport is shorter than content. */
  border-right: 1px solid #eee;
}
/* Sidebar navigation */

.sidebar {
  padding-left: 0;
  padding-right: 0;
}

.sidebar .nav {
  margin-bottom: 20px;
}

.sidebar .nav-item {
  width: 100%;
}

.sidebar .nav-item + .nav-item {
  margin-left: 0;
}

.sidebar .nav-link {
  border-radius: 0;
}
/*
 * Dashboard
 */
/* Placeholders */

.placeholders {
  padding-bottom: 3rem;
}

.placeholder img {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

select option[data-default] {
  display: none;
}

.medecins-form {
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// contratsNew.vue?0cfc285e